import * as tenantService from 'services/tenant-service';
// import * as deviceService from 'services/device-service';
import { ApiResponse } from 'types/api/api-response';
// import * as HeaderConstants from './header-constants';
import { Guid } from 'types/guid';

export async function postWithResponseAndHeaders<T>(
      url: string,
      // tslint:disable-next-line:no-any
      request: any,
      token?: string,
      tenantId?: Guid,
      language?: string
    ): Promise<ApiResponse<T>> {
  const result = await fetch(url, {
    method: 'POST',
    headers: await buildHeaders(token,  tenantId, language, 'application/json'),
    body: JSON.stringify(request)
  });
  if (result.status !== 200) {
    let errorMessage = result.statusText;
    if (result.body) {
      const json = await result.json();
      if (json.message) {
        errorMessage = json.message;
      }
    }

    throw new Error(errorMessage);
  }
  return {
    headers: result.headers,
    body: (await result.json()) as T
  } as ApiResponse<T>;
}

export async function postWithResponse<T>(
      url: string,
      // tslint:disable-next-line:no-any
      request: any,
      token?: string,
      tenantId?: Guid,
      language?: string
    ): Promise<T> {
  const result = await post(url, request, token, tenantId, language);
  return (await result.json()) as T;
}

// tslint:disable-next-line:no-any
export async function post(url: string, request: any, token?: string, tenantId?: Guid, language?: string): Promise<Response> {
  const result = await fetch(url, {
    method: 'POST',
    headers: await buildHeaders(token,  tenantId, language, 'application/json'),
    body: JSON.stringify(request)
  });
  if (result.status !== 200) {
    let errorMessage = result.statusText;
    if (result.body) {
      const json = await result.json();
      if (json.message) {
        errorMessage = json.message;
      }
    }

    throw new Error(errorMessage);
  }

  return result;
}

// tslint:disable-next-line:no-any
export async function get<T>(url: string, token?: string, tenantId?: Guid, language?: string): Promise<T> {
  const options: RequestInit = {
    method: 'GET'
  };

  if (token || language || tenantId) {
    options.headers = await buildHeaders(token,  tenantId, language);
  }
  url = url + '/01106141410001492173555785517613';
  const result = await fetch(url, options);
  if (result.status !== 200) {
    let errorMessage = result.statusText;
    if (result.body) {
      const json = await result.json();
      if (json.message) {
        errorMessage = json.message;
      }
    }

    throw new Error(errorMessage);
  }

  return (await result.json()) as T;
}

// tslint:disable-next-line:no-any
export async function post2(url: string, request: any, token?: string, tenantId?: Guid, language?: string) {
  var options: RequestInit = {
    method: 'POST',
    body: JSON.stringify(request)
  };
  options.headers = await buildHeaders(token, tenantId, language, 'application/json');
  url = url;
  const result = await fetch(url, options);
  if (result.status !== 200) {
    let errorMessage = result.statusText;
    if (result.body) {
      const json = await result.json();
      if (json.message) {
        errorMessage = json.message;
      }
    }

    throw new Error(errorMessage);
  }

  return (await result.json());
}

// tslint:disable-next-line:no-any
export async function putWithResponse<T>(url: string, request: any, token?: string, tenantId?: Guid, language?: string): Promise<T> {
  const result = await put(url, request, token, tenantId, language);
  return (await result.json()) as T;
}

// tslint:disable-next-line:no-any
export async function put(url: string, request: any, token?: string, tenantId?: Guid, language?: string): Promise<Response> {
  const result = await fetch(url, {
    method: 'PUT',
    headers: await buildHeaders(token,  tenantId, language),
    body: JSON.stringify(request)
  });
  if (result.status !== 200) {
    let errorMessage = result.statusText;
    if (result.body) {
      const json = await result.json();
      if (json.message) {
        errorMessage = json.message;
      }
    }

    throw new Error(errorMessage);
  }

  return result;
}

// tslint:disable-next-line:no-any
export async function del(url: string, token?: string, tenantId?: Guid, language?: string): Promise<void> {
  const result = await fetch(url, {
    method: 'DELETE',
    headers: await buildHeaders(token,  tenantId, language)
  });
  if (result.status !== 200) {
    let errorMessage = result.statusText;
    if (result.body) {
      const json = await result.json();
      if (json.message) {
        errorMessage = json.message;
      }
    }

    throw new Error(errorMessage);
  }
}

async function buildHeaders(token?: string, tenantId?: Guid, language?: string, contentType?: string) {
  let headers = {
    // 'Accept': 'application/json',
    // 'Content-Type': 'application/json',
    'X-Apikey': 'API-344188D917D198F5B47F37F0'
  };
  if (token) {
    // tslint:disable-next-line:no-string-literal
    headers['Authorization'] = 'Bearer ' + token;
    headers['X-OptelAuth'] = token;
  }
  if (contentType) {
    headers['Content-Type'] = contentType;
  }
  if (language) {
    headers['Accept-Language'] = language;
  }
  if (!tenantId) {
    tenantId = await tenantService.getTenantId();
  }

  // headers[HeaderConstants.TenantId] = tenantId;
  // headers[HeaderConstants.DeviceId] = await deviceService.getDeviceId();

  return headers;
}


// WEBPACK FOOTER //
// ./src/api/fetch.ts